export const VIEW_GROUP_NGO = "NGO"
export const VIEW_GROUP_UNIVERSITY = "UNIVERSITY"
export const VIEW_GROUP_DOCTOR = "DOCTOR"
export const VIEW_GROUP_CLINIC = "CLINIC"
export const VIEW_GROUP_HOSPITAL = "HOSPITAL"